import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import {
  fetchMemberWhoami, getMemberToken, isPartnerSession, SESSION_EXPIRED_EVENT,
} from "../lib/memberSession";

// Pages fetch data in their own effects, so validate before mounting the page
// or its sidebar. A guard inside the layout cannot protect sibling content.
export default function RequireMemberSession({ admin = false }) {
  const [session, setSession] = useState({ checking: true });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const token = getMemberToken();
    const expired = (event) => setSession({
      signedOut: true,
      sessionExpired: true,
      partnerSessionExpired: event.detail?.partnerSessionExpired || isPartnerSession(token),
    });
    window.addEventListener(SESSION_EXPIRED_EVENT, expired);
    setSession({ checking: true });
    if (!token) {
      setSession({ signedOut: true });
    } else {
      fetchMemberWhoami().then((member) => {
        if (!cancelled && token === getMemberToken()) setSession({ member });
      }).catch((error) => {
        if (cancelled) return;
        if (error.status === 401) {
          setSession({ signedOut: true, sessionExpired: true, partnerSessionExpired: isPartnerSession(token) });
        } else {
          setSession({ error: true });
        }
      });
    }
    return () => {
      cancelled = true;
      window.removeEventListener(SESSION_EXPIRED_EVENT, expired);
    };
  }, [attempt]);

  if (session.signedOut) return <Navigate to="/agent/login" replace state={{
    sessionExpired: session.sessionExpired,
    partnerSessionExpired: session.partnerSessionExpired,
  }} />;
  if (session.error) return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4">
      <p role="alert">Unable to check your session. Please try again.</p>
      <button className="text-primary underline" onClick={() => setAttempt((value) => value + 1)}>Try again</button>
    </div>
  );
  if (session.checking) return <div role="status" className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">Checking your session…</div>;
  if (!session.member) return <Navigate to="/agent/login" replace />;
  if (!admin && session.member.delegatedAdmin && !session.member.workspaceMember) return <Navigate to="/admin/team" replace />;
  if (admin && session.member.role !== "admin") return <Navigate to="/agent" replace />;
  return <Outlet />;
}
